import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./SubscriptionModal.css";

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
    <circle cx="8" cy="8" r="8" fill="currentColor" fillOpacity="0.12" />
    <path d="M4.5 8l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const plans = [
  {
    key: "true_mindsets_yearly",
    period: "yearly",
    badge: "subscriptionModal.save",
    perLabel: "subscriptionModal.perYear",
    priceKey: "subscriptionModal.yearlyPrice",
    labelKey: "subscriptionModal.yearly",
    features: ["subscriptionModal.feature1", "subscriptionModal.feature2", "subscriptionModal.feature3"],
  },
  {
    key: "true_mindsets_monthly",
    period: "monthly",
    badge: null,
    perLabel: "subscriptionModal.perMonth",
    priceKey: "subscriptionModal.monthlyPrice",
    labelKey: "subscriptionModal.monthly",
    features: ["subscriptionModal.feature1", "subscriptionModal.feature2"],
  },
];

const SubscriptionModal = ({ isOpen, onClose }) => {
  const [selectedOption, setSelectedOption] = useState("true_mindsets_yearly");
  const { t } = useTranslation();

  const handleSubscribe = () => {
    onClose(selectedOption);
  };

  if (!isOpen) return null;

  return (
    <div className="sub-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="sub-modal">
        {/* Close button */}
        <button className="sub-close" onClick={() => onClose()} aria-label="Close">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M14 4L4 14M4 4l10 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>

        {/* Header */}
        <div className="sub-header">
          <div className="sub-icon-wrap">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6L12 2z"
                fill="currentColor" />
            </svg>
          </div>
          <h2 className="sub-title">{t("subscriptionModal.title")}</h2>
          <p className="sub-subtitle">{t("subscriptionModal.subtitle", "Choose the plan that works best for you")}</p>
        </div>

        {/* Plan cards */}
        <div className="sub-plans">
          {plans.map((plan) => {
            const isSelected = selectedOption === plan.key;
            return (
              <div
                key={plan.key}
                className={`sub-plan ${isSelected ? "sub-plan--selected" : ""} ${plan.badge ? "sub-plan--featured" : ""}`}
                onClick={() => setSelectedOption(plan.key)}
              >
                {plan.badge && (
                  <div className="sub-badge">{t(plan.badge)}</div>
                )}

                <div className="sub-plan-name">{t(plan.labelKey)}</div>

                <div className="sub-price-row">
                  <span className="sub-price">{t(plan.priceKey)}</span>
                </div>
                <div className="sub-per">{t(plan.perLabel)}</div>

                <div className="sub-divider" />

                {/* <ul className="sub-features">
                  {plan.features.map((fKey) => (
                    <li key={fKey} className="sub-feature-item">
                      <CheckIcon />
                      <span>{t(fKey, fKey.split(".").pop())}</span>
                    </li>
                  ))}
                </ul> */}

                <div className={`sub-radio ${isSelected ? "sub-radio--on" : ""}`} />
              </div>
            );
          })}
        </div>

        {/* Actions */}
        <button className="sub-cta" onClick={handleSubscribe}>
          {t("buttonTitles.next")}
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ marginLeft: 6 }}>
            <path d="M4 9h10M10 5l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        <button className="sub-cancel" onClick={() => onClose()}>
          {t("buttonTitles.cancel", "Cancel")}
        </button>
      </div>
    </div>
  );
};

export default SubscriptionModal;
